import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/close.svg'


const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = { class: "pane" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "text"
}
const _hoisted_5 = ["src"]

import { reactive, onMounted } from "vue"
import store from "@/store"


export default /*@__PURE__*/_defineComponent({
  __name: 'customer',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const state = reactive({
    show: true,
    text: '',
    url: '',
    type: 0,
    desc: '',
})
const onCancel = () => {
    state.show = false
    emit('close', {})
}

onMounted(() => {
    const info = store.getters
    state.url = info.infoUrl
    state.type = info.infoType
    state.desc = info.infoDesc
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text" }, "客服二维码", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "X",
          class: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onCancel()))
        })
      ]),
      (state.desc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(state.desc), 1))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        src: state.url,
        alt: "客服图片",
        class: "qrcode"
      }, null, 8, _hoisted_5),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "desc" }, "长按保存二维码到相册", -1))
    ]),
    _createElementVNode("div", {
      class: "overlay",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onCancel()))
    })
  ]))
}
}

})